import { observer } from "mobx-react-lite";
import * as React from "react";
import { TaskViewVisualStore } from "../stores";
import ActionInputForm from "./ActionInputForm";
import AppModal from "../../common/components/AppModal";

type Props = {
    actionId: string;
    store: TaskViewVisualStore;
};

const ActionInputDialog: React.FC<Props> = ({ actionId, store }) => {
    return (
        <AppModal
            title={
                store.seletedActionModel?.title ??
                store.seletedActionModel?.name ??
                "Parameters"
            }
            open={store.selectedAction !== undefined}
            className="alpha-modal comment-in-modal"
            closable={false}
            cancelButtonTitle="Cancel"
            onCancelClick={() => store.setSelectedAction(undefined)}
            cancelButtonProps={{
                "data-id": "execute-action-cancel-button",
                size: undefined,
            }}
            submitButtonTitle="Execute"
            submitButtonProps={{
                "data-id": "execute-action-button",
                form: "execute-action-form",
                loading: store.isActionLoading,
                size: undefined,
            }}
        >
            <ActionInputForm actionId={actionId} store={store} />
        </AppModal>
    );
};

export default observer(ActionInputDialog);
